import {
    Popover,
    Transition
} from "@headlessui/react";

import {
    MenuIcon,
    XIcon,
    ChevronDownIcon
} from "@heroicons/react/outline";

import {Fragment} from 'react'

import {Link, useLocation} from "react-router-dom";

import logo from "../../assets/logo.png"

const navigation = [
    {name: 'Pricing', href: '/pricing'},
    {name: 'About', href: '/about'},
    {name: 'Support', href: '/support'},
]

const products = [
    {
        id: 0,
        name: 'Scrim Finder',
        description: "Learn about tips, product updates and company culture."
    },
    {
        id: 1,
        name: 'Scouting',
        description: 'Scoutli offers an extensive range of player database with advanced analytics and player ratings.'
    },
    {
        id: 2,
        name: 'Team Management',
        description: 'Scoutli enables teams to track their financials, important dates, players data, and more. Data-driven player management.'
    },
    {
        id: 3,
        name: 'Analytics and Reports',
        description: "Scoutli offers a variety of reports to help you: Tournament Performance, Player Scouting and Player Performance."
    },
    {
        id: 4,
        name: 'Player Data',
        description: "Scoutli got you covered with tools to level up your game: Playbooks, Lineups, Heatmaps, 2D Replays, Map planner & more."
    },
    {
        id: 5,
        name: 'Data as a Service',
        description: "We make finding and using reliable data for your esports events easy. Bringing Data to the game."
    }
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Navbar = ({setProductType}) => {
    let location = useLocation();

    return (
        <Popover className="relative bg-white">
            <div className="flex justify-between items-center max-w-7xl mx-auto px-6 pt-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                    <Link to="/">
                        <span className="sr-only">Scoutli</span>

                        <img
                            className="h-8 w-auto sm:h-10"
                            src={logo}
                            alt="Scoutli"
                        />
                    </Link>
                </div>

                <div className="-mr-2 -my-2 md:hidden">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 transition-colors hover:bg-gray-100 focus:outline-none">
                        <span className="sr-only">Open menu</span>

                        <MenuIcon className="h-6 w-6" aria-hidden="true"/>
                    </Popover.Button>
                </div>

                <Popover.Group as="nav" className="hidden md:flex space-x-10">
                    <Popover className="relative">
                        {({open}) => (
                            <>
                                {location.pathname === "/product" && (
                                    <Popover.Button className={classNames(
                                        open ? 'text-gray-900' : 'text-gray-500',
                                        'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900'
                                    )}
                                    >
                                        <span>Product</span>

                                        <ChevronDownIcon
                                            className={classNames(
                                                open ? 'text-gray-600' : 'text-gray-400',
                                                'ml-2 h-5 w-5 group-hover:text-gray-500'
                                            )}
                                            aria-hidden="true"
                                        />
                                    </Popover.Button>
                                )}

                                {location.pathname !== "/product" && (
                                    <Link key="Product" to="/product"
                                          className="text-base font-medium text-gray-500 hover:text-gray-900">
                                        Product
                                    </Link>
                                )}

                                <Transition
                                    as={Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                >
                                    <Popover.Panel className="absolute z-10 -ml-4 mt-3 transform w-96 max-w-md lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                                        <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                                            <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-1">
                                                {products.map((item) => (
                                                    <Link
                                                        key={item.name}
                                                        onClick={() => {
                                                            if (typeof setProductType === "function"){
                                                                setProductType(item.id)
                                                            }
                                                        }}
                                                        to="/product"
                                                        className="-m-3 p-3 flex items-start rounded-lg transition-colors hover:bg-gray-50"
                                                    >
                                                        <div className="ml-4">
                                                            <p className="text-base font-medium text-gray-900">{item.name}</p>

                                                            <p className="mt-1 text-sm text-gray-500 max-w-sm">{item.description}</p>
                                                        </div>
                                                    </Link>
                                                ))}
                                            </div>
                                        </div>
                                    </Popover.Panel>
                                </Transition>
                            </>
                        )}
                    </Popover>

                    {navigation.map((item) => (
                        <Link key={item.name} to={item.href}
                           className="text-base font-medium text-gray-500 hover:text-gray-900">
                            {item.name}
                        </Link>
                    ))}
                </Popover.Group>
                <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                    <Link to="/get-started"
                       className="whitespace-nowrap font-normal text-base text-gray-500 transition-colors hover:text-gray-900">
                        Get Started
                    </Link>

                    <Link
                        to="/login"
                        className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base text-white bg-brand transition-colors hover:bg-indigo-600"
                    >
                        Log in
                    </Link>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Popover.Panel
                    focus
                    className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                >
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                        <div className="pt-5 pb-6 px-5">
                            <div className="flex items-center justify-between">
                                <div>
                                    <Link to="/">
                                        <img
                                            className="h-8 w-auto"
                                            src={logo}
                                            alt="Scoutli"
                                        />
                                    </Link>
                                </div>

                                <div className="-mr-2">
                                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 transition-colors hover:bg-gray-100 focus:outline-none">
                                        <span className="sr-only">Close menu</span>

                                        <XIcon className="h-6 w-6" aria-hidden="true"/>
                                    </Popover.Button>
                                </div>
                            </div>

                            <div className="mt-8">
                                <nav className="grid grid-cols-1 gap-7">
                                    {location.pathname === "/product" && products.map((item) => (
                                            <Link
                                                key={item.name}
                                                onClick={() => {
                                                    if (typeof setProductType === "function"){
                                                        setProductType(item.id)
                                                    }
                                                }}
                                                to="/product"
                                                className="-m-3 p-3 flex items-center rounded-lg transition-colors hover:bg-gray-50"
                                            >
                                                <div className="ml-4 text-base font-medium text-gray-900">{item.name}</div>
                                            </Link>
                                    ))}

                                    {location.pathname !== "/product" && (
                                        <Link
                                            key="Product"
                                            to="/product"
                                            className="-m-3 p-3 flex items-center rounded-lg transition-colors hover:bg-gray-50"
                                        >
                                            <div className="ml-4 text-base font-medium text-gray-900">Product</div>
                                        </Link>
                                    )}

                                    {navigation.map((item) => (
                                        <Link
                                            key={item.name}
                                            to={item.href}
                                            className="ml-4 text-base font-medium text-gray-900 hover:text-gray-700 transition-colors"
                                        >
                                            {item.name}
                                        </Link>
                                    ))}
                                </nav>
                            </div>
                        </div>
                        <div className="pb-6 px-5">
                            <div className="mt-6">
                                <Link
                                    to="/support"
                                    className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base text-white bg-indigo-600 transition-colors hover:bg-indigo-700"
                                >
                                    Request Demo
                                </Link>

                                {/*<p className="mt-6 text-center text-base font-medium text-gray-500">*/}
                                {/*    <Link to="/login" className="text-gray-900">*/}
                                {/*        Log in*/}
                                {/*    </Link>*/}
                                {/*</p>*/}
                            </div>
                        </div>
                    </div>
                </Popover.Panel>
            </Transition>
        </Popover>
    )
}

export default Navbar;